import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  OnInit,
  Output,
  ViewChild,
  PLATFORM_ID,
  Inject,
} from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../../../services/auth.service'; // Adjusted path
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-navbar', // Assuming a different selector for admin navbar
  standalone: false,
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css'],
})
export class NavbarComponent implements OnInit {
  @Output() sidebarToggle = new EventEmitter<void>();
  @ViewChild('sidebarContent') sidebarContent!: ElementRef;

  isSidebarClosed = false;
  isMobileMenuOpen = false;
  isDropdownOpen = false;
  isDropdownOpen1 = false;
  isDropdownServicosOpen = false; // Novo estado para dropdown Vistoria
  isDropdownJornadaOpen = false; // Novo estado para dropdown Jornada
  isDragging = false;
  isMobile = false;
  showLogoutConfirm = false;
  isHamburgerActive = false;
  usuario: any = null;
  startX = 0;
  scrollLeft = 0;

  constructor(
    private router: Router,
    private authService: AuthService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit(): void {
    this.usuario = this.authService.getUsuario();
    if (this.isBrowser()) {
      this.checkMobile();
    }
  }

  // Check if we're in the browser environment
  isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }

  // Consider large screen (desktop) as width >= 768px
  isLargeScreen(): boolean {
    return this.isBrowser() ? this.getWindowWidth() >= 768 : false;
  }

  // detecta se o dispositivo tem suporte a touch
  private isTouchDevice(): boolean {
    if (!this.isBrowser()) return false;
    return 'ontouchstart' in window || (navigator as any).maxTouchPoints > 0;
  }

  // Get window inner width safely
  getWindowWidth(): number {
    return this.isBrowser() ? window.innerWidth : 0;
  }

  // Considera "mobile" apenas quando a largura for pequena E o dispositivo tiver touch
  private checkMobile(): void {
    const width = this.getWindowWidth();
    const hasTouch = this.isTouchDevice();
    this.isMobile = width < 768 && hasTouch;
  }

  @HostListener('window:resize')
  onResize(): void {
    if (this.isBrowser()) {
      const wasMobile = this.isMobile;
      this.checkMobile();
      // Se saímos do modo mobile, garantir que o overlay seja fechado e o ícone sincronizado
      if (wasMobile && !this.isMobile) {
        this.closeMobileMenu();
        // no desktop, o ícone reflete o estado da sidebar
        // On large screens invert behaviour: show X when sidebar is closed
        this.isHamburgerActive = this.isLargeScreen() ? this.isSidebarClosed : !this.isSidebarClosed;
      }
    }
  }

  // Getters usados no HTML
  get nomeUsuario(): string {
    return this.usuario?.nome ?? '';
  }

  get userName(): string {
    return this.usuario?.userName ?? '';
  }

  get role(): string {
    return this.usuario?.role ?? '';
  }

  get nomeDaEmpresa(): string {
    return this.usuario?.nomeDaEmpresa ?? '';
  }

  get suporteLink(): string {
    return this.role === 'SuperAdministrador' ? '/admin/suporte/superadmin' : '/admin/suporte';
  }

  // Renamed original logout logic
  private performLogout(): void {
    this.authService.logout();
  }

  // Method to show the confirmation dialog
  requestLogout(): void {
    this.showLogoutConfirm = true;
  }

  // Method called when user confirms logout in the dialog
  confirmLogout(): void {
    this.showLogoutConfirm = false;
    this.authService.logout(); // This will handle sending data to endpoint and redirecting
  }

  // Method called when user cancels logout in the dialog
  cancelLogout(): void {
    this.showLogoutConfirm = false;
  }

  toggleSidebar(): void {
    this.isSidebarClosed = !this.isSidebarClosed;
    this.sidebarToggle.emit();
    // sincroniza ícone do hambúrguer no desktop
    if (!this.isMobile) {
      // On large screens invert behaviour: when sidebar is closed show X
      this.isHamburgerActive = this.isLargeScreen() ? this.isSidebarClosed : !this.isSidebarClosed;
      this.isMobileMenuOpen = false;
    }
    if (this.isBrowser()) {
      // Use canonical values and keep body class in sync
      document.body.classList.toggle('sidebar-closed', this.isSidebarClosed);
      localStorage.setItem('sidebarState', this.isSidebarClosed ? 'sidebar-closed' : 'sidebar-open');
      try {
        const ev = new CustomEvent('sidebarToggled', { detail: { closed: this.isSidebarClosed } });
        window.dispatchEvent(ev);
      } catch (e) {
        try { window.dispatchEvent(new Event('sidebarToggled')); } catch (err) {}
      }
    }
  }

  onHamburgerClick(event?: MouseEvent): void {
    if (event) event.stopPropagation();
    // open mobile overlay menu instead of sidebar when on mobile
    if (this.isMobile) {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
      this.isHamburgerActive = this.isMobileMenuOpen;
      // Do not force dropdown state here; overlay will render subitems directly.
      if (!this.isMobileMenuOpen) {
        this.closeDropdowns();
      }
    } else {
      this.toggleSidebar();
      // toggleSidebar already updates isHamburgerActive correctly depending on screen size
    }
  }

  closeMobileMenu(): void {
    this.isMobileMenuOpen = false;
    this.closeDropdowns();
    this.isHamburgerActive = false;
  }

  onNavLinkClick(): void {
    // close mobile menu after navigation
    if (this.isMobile) this.closeMobileMenu();
    this.closeDropdowns();
  }

  toggleDropdown1(event?: MouseEvent): void {
    if (event) event.stopPropagation();
    this.isDropdownOpen1 = !this.isDropdownOpen1;
    if (this.isDropdownOpen1) {
      this.isDropdownOpen = false;
      this.isDropdownServicosOpen = false;
      this.isDropdownJornadaOpen = false;
    }
  }

  toggleDropdown(event?: MouseEvent): void {
    if (event) event.stopPropagation();
    this.isDropdownOpen = !this.isDropdownOpen;
    if (this.isDropdownOpen) {
      this.isDropdownOpen1 = false;
      this.isDropdownServicosOpen = false;
      this.isDropdownJornadaOpen = false;
    }
  }

  toggleDropdownServicos(event?: MouseEvent): void {
    if (event) event.stopPropagation();
    this.isDropdownServicosOpen = !this.isDropdownServicosOpen;
    // Fecha outros dropdowns ao abrir este
    if (this.isDropdownServicosOpen) {
      this.isDropdownOpen = false;
      this.isDropdownOpen1 = false;
      this.isDropdownJornadaOpen = false;
    }
  }

  toggleDropdownJornada(event?: MouseEvent): void {
    if (event) event.stopPropagation();
    this.isDropdownJornadaOpen = !this.isDropdownJornadaOpen;
    // Fecha outros dropdowns ao abrir este
    if (this.isDropdownJornadaOpen) {
      this.isDropdownOpen = false;
      this.isDropdownOpen1 = false;
      this.isDropdownServicosOpen = false;
    }
  }

  closeDropdowns(): void {
    this.isDropdownOpen = false;
    this.isDropdownOpen1 = false;
    this.isDropdownJornadaOpen = false;
    this.isDropdownServicosOpen = false; 
  }

  onMouseDown(event: MouseEvent): void {
    if (!this.isMobile) return; // Only enable drag on mobile sidebar
    this.isDragging = true;
    this.startX = event.pageX - this.sidebarContent.nativeElement.offsetLeft;
    this.scrollLeft = this.sidebarContent.nativeElement.scrollLeft;
  }

  onMouseMove(event: MouseEvent): void {
    if (!this.isDragging || !this.isMobile) return;
    const x = event.pageX - this.sidebarContent.nativeElement.offsetLeft;
    const walk = (x - this.startX) * 2; // Adjust multiplier for sensitivity
    this.sidebarContent.nativeElement.scrollLeft = this.scrollLeft - walk;
  }

  onMouseUp(): void {
    if (!this.isMobile) return;
    this.isDragging = false;
  }

  onMouseLeave(): void {
    if (!this.isMobile) return;
    // Keep dragging state if mouse leaves while button is still pressed
    // this.isDragging = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const clickedElement = event.target as HTMLElement;
    const isDropdownToggle =
      clickedElement.closest('.nav-link.w-100') !== null;
    const isInsideDropdown =
      clickedElement.closest('.dropdown-content') !== null;

    // Fecha dropdowns se clicar fora dos toggles ou dropdowns
    if (!isDropdownToggle && !isInsideDropdown) {
      this.closeDropdowns();
    }
  }
}
